import React, { useEffect, useState, Fragment, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import ListGroupsPageTitle from '../../../Layout/AppMain/ListGroupsPageTitle';
import CardNoGroup from '../../../Layout/AppMain/CardNoGroups';
import ButtonGroupRoles from '../../../Layout/AppMain/ButtonGroupRoles';
import api from '../../../services/api';
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Container,
    CardHeader,
} from 'reactstrap';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
// import ReachOutLabels from '../../../enums/ReachOutLabels';

export default function ListGroups() {
    const {
        toggleLoading,
        storeCurrentGroup,
        removeCurrentGroup,
        authenticated,
        setCurrentScript
    } = useAuth();
    const history = useHistory();
    const [groups, setGroups] = useState([]);
    const [messages, setMessages] = useState({});
    const [noGroups, setNoGroups] = useState(false);
    const [refreshLoading, setRefreshLoading] = useState(false);

    const goToGroup = useCallback(
        (type, group) => {
            setCurrentScript(null);
            storeCurrentGroup({
                role: type,
                ...group,
            });
            localStorage.setItem('@Reachout:groupRole', JSON.stringify(type));
            history.push(`/group/${group.id}`);
        },
        [history, storeCurrentGroup, setCurrentScript]
    );

    const listUserGroups = useCallback(() => {
        removeCurrentGroup();
        toggleLoading(true);
        setRefreshLoading(true);
        api.get(`/ro.team.listUserGroups`)
            .then((response) => {
                if (!response.data.hasOwnProperty('errorMessage')) {
                    setGroups(response.data.items);
                    if (response.data.items.length === 0) {
                        setNoGroups(true);
                    }
                    if (response.data.messages) {
                        setMessages(response.data.messages);
                    }
                    // else if (response.data.length === 1 && response.data[0].roles.length === 1 && response.data[0].roles[0].code === 3) {
                    //     goToGroup(response.data[0].roles[0].label, response.data[0]);
                    // }
                } else {
                    toast.error(response.data.errorMessage);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
                setRefreshLoading(false);
            });
    }, [toggleLoading, removeCurrentGroup, setRefreshLoading, setMessages]);

    useEffect(() => {
        listUserGroups();
    }, [listUserGroups]);

    const capitalize = (s) => {
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    const userInfo = useCallback(() => {
        if (authenticated.user) {
            return authenticated.user;
        } else {
            return authenticated;
        }
    }, [authenticated]);

    const rolesFilter = useCallback(
        (roles) => {
            const filtered = [];
            roles.map((current) => {
                if (current.label === 'owner') {
                    return false;
                }
                if (
                    userInfo().role === 'coordinator' &&
                    (current.code === 4 || current.code === 1)
                ) {
                    filtered.push(current);
                } else if (current.label === userInfo().role) {
                    filtered.push(current);
                }
                return false;
            });
            return filtered;
        },
        [userInfo]
    );

    const countCurrentGroups = useCallback(() => {
        let count = 0;
        groups.map((group) => {
            if (rolesFilter(group.roles).length > 0) {
                count++;
            }
            return true;
        });
        return count;
    }, [groups, rolesFilter]);

    const groupMessage = useCallback(() => {
        let message = '';

        // if (!noGroups && countCurrentGroups() > 0) {
        //     message = 'Select a Group below';
        // } else {
        //     message = 'Ask a Coordinator for a group invitation';
        // }

        // if (userInfo().role && userInfo().role === 'coordinator') {
        //     message += ' or create a new group';
        // }

        if (userInfo().role) {
            if (userInfo().role && userInfo().role === 'coordinator') {
                if (!noGroups && countCurrentGroups() > 0) {
                    message = 'Stay connected. Together with your volunteer group to support Seniors';
                } else {
                    message = 'Looking to help your community? Create a new group to connect with Seniors';
                }
            } else {
                if (userInfo().role && userInfo().role === 'giver') {
                    if (!noGroups && countCurrentGroups() > 0) {
                        message = 'Ready to help? Connect with Seniors in your group';
                    } else {
                        message = 'Ready to help? Join a group to connect with Seniors';
                    }
                } else {
                    if (userInfo().role && userInfo().role === 'receiver') {
                        if (!noGroups && countCurrentGroups() > 0) {
                            message = 'Hear from a friendly voice of a Senior Link volunteer';
                        } else {
                            message = 'We need to talk. Find a group and stay connected';
                        }
                    } else {
                        message = 'Welcome to Seniors Living In Neighborhood Kindness!';
                    }
                }
            }
        } else {
            message = 'Seniors Living In Neighborhood Kindness';
        }

        return message;
    }, [noGroups, userInfo, countCurrentGroups]); 

    const getMessage = useCallback(() => {
        const role = userInfo().role;
        if (messages.hasOwnProperty(role) && messages[role]['msg']) {
            return messages[role]['msg'];
        }
    }, [userInfo, messages]);

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <ListGroupsPageTitle
                    heading="Home"
                    subheading={groupMessage()}
                    icon="pe-7s-home icon-gradient bg-ripe-malin fontWeigth800"
                    showCreateBtn={true}
                    refreshCallback={listUserGroups}
                    refreshLoading={refreshLoading}
                />
                <Container>
                    <Row>
                        {groups.map((group) => (
                            <Fragment key={group.id}>
                                {rolesFilter(group.roles).length > 0 && (
                                    <Col sm="4" className="mb-4">
                                        <Card>
                                            <CardBody>
                                                <div className="grid-menu grid-menu-2col">
                                                    <Button
                                                        className="btn-icon-vertical btn-square btn-transition"
                                                        outline
                                                        color="link"
                                                        onClick={() => {
                                                            const role = rolesFilter(group.roles);
                                                            goToGroup(role[0].label, group, role[0].code)
                                                        }}
                                                    >
                                                        <i className="lnr-users btn-icon-wrapper btn-icon-lg mb-3">
                                                            {' '}
                                                        </i>
                                                        {group.title}
                                                        <br />
                                                        <small>Group
                                                            {/*
                                                                ReachOutLabels[
                                                                    userInfo()
                                                                        .role
                                                                ]
                                                            */}
                                                        </small>
                                                    </Button>
                                                    <div className="text-center">
                                                        <ButtonGroupRoles
                                                            roles={rolesFilter(
                                                                group.roles
                                                            )}
                                                            group={group}
                                                            goToGroup={
                                                                goToGroup
                                                            }
                                                            capitalize={
                                                                capitalize
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                )}
                            </Fragment>
                        ))}
                        {/* {noGroups && userInfo().role === 'coordinator' && (
                            
                        )} */}
                        <CardNoGroup
                            showCreateBtn={userInfo().role === 'coordinator'}
                            showJoinBtn={true}
                            noGroups={noGroups}
                        />
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Card className="main-card mb-3">
                                <CardHeader>Welcome to Senior Link</CardHeader>
                                <CardBody>
                                    
                                    {/* getMessage() */}

                                    <div dangerouslySetInnerHTML={{ __html: getMessage() }} />
                                    
                                </CardBody>
                                {/* <CardFooter className="d-block text-right">
                                <Button size="lg" color="success">I need help</Button>
                            </CardFooter> */}
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </CSSTransitionGroup>
        </Fragment>
    );
}
